import { axiosInstance } from "contexts/axiosApiInstance";
import { createLogger } from "debug/DebugingLogger";
import { ModelDeletionAnalysis } from "target_wasm";
import { handleTableOwnershipTransfer } from "components/canvas/detailsSide/tableDetails/TableServices";

const log = createLogger("DeletionServices");

export const fetchModelDeletionAnalysis = async (
  modelId: string,
): Promise<ModelDeletionAnalysis> => {
  try {
    const response = await axiosInstance.get(
      `/action/model/${modelId}/tables-for-deletion`,
    );
    return ModelDeletionAnalysis.from_js(response.data);
  } catch (error) {
    log.error("Failed to fetch or parse Model analysis", error);
    throw error;
  }
};

export const transferTableOwnership = async (
  tableId: string,
  fromModelId: string,
  toModelId: string,
): Promise<{ success: boolean; message: string }> => {
  try {
    const result = await handleTableOwnershipTransfer(
      tableId,
      fromModelId,
      toModelId,
    );
    if (!result.success) {
      log.error(`Failed to transfer table ${tableId}: ${result.message}`);
    }
    return result;
  } catch (error) {
    log.error("transferTableOwnership: Error transferring table", error);
    throw error;
  }
};
